import MmsRepository from "./MmsRepository";

export default class MmsService {
  private readonly mmsRepository: MmsRepository = new MmsRepository();

  async getModelVersions(locationId: string) {
    try {
      return await this.mmsRepository.getModelVersions(locationId);
    } catch (error) {
      console.error(error);
    }
  }
}
